export const openAppSettings = () => {
    if (window.RahmetApp.openAppSettings) window.RahmetApp.openAppSettings();
};
